export const pwaInstallHeading = {
    en: "Find HealthVaani easily - download it to your home screen.",
    hi: "हेल्थवाणी आसानी से ढूँढें - होम स्क्रीन पर डाउनलोड करें।",
    or: "ହେଲଥୱାନି ସହଜରେ ସନ୍ଧାନ କରନ୍ତୁ - ଏହାକୁ ନିଜ ହୋମ ସ୍କ୍ରିନରେ ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    mr: "हेल्थवाणी सहजपणे शोधा – होम स्क्रीनवर डाउनलोड करा |"
}

export const pwaInstallButton = {
    en: "Download",
    hi: "डाउनलोड",
    or: "ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
    mr: "डाउनलोड"
}

export const pwaInstallCancel = {
    en: "Later",
    hi: "बाद में",
    or: "ପରେ",
    mr: "नंतर"
}


export const pwaInstallAddToHomeScreen = {
    en: "Add to Home Screen? Click Install Now",
    hi: "ऐप को फोन में जोड़ें - अभी इंस्टॉल करें",
    or: "ଆପ୍‌କୁ ଫୋନ୍‌ରେ ଯୋଗ କରନ୍ତୁ",
    mr: "ॲप फोनमध्ये जोडा – आत्ताच इन्स्टॉल करा"
}